<template>
  <el-dialog
    :title="title"
    center
    :visible.sync="show"
    :before-close="handleClose"
    :custom-class="customClass"
    :close-on-click-modal="closeOnClickModal"
    :close-on-press-escap="closeOnPressEscap"
    :show-close="showClose"
  >
    <slot></slot>
  </el-dialog>
</template>

<script>
// dialog 基类
export default {
  name: "Dialog",
  props: {
    title: String,
    show: Boolean,
    customClass: String,
    closeOnClickModal: {
      type: Boolean,
      default: () => true
    },
    closeOnPressEscap: {
      type: Boolean,
      default: () => true
    },
    showClose: {
      type: Boolean,
      default: () => true
    }
  },
  methods: {
    handleClose() {
      this.$parent.cancelDialog();
    }
  }
};
</script>

<style lang="less" scoped>
/**
  dialog 基类，其它 dialog 继承该 dialog
  功能：重置 dialog style
*/
/deep/ .el-dialog__header {
  padding: 16px;

  .el-dialog__title {
    color: #111;
    font-size: 18px;
  }
  .el-dialog__close {
    color: #333;
  }
}
</style>
